export default __webpack_public_path__ + "static/media/7A6D70CF-2632-41AB-88F4-D96E676D126D_1_105_c.fd3d8b08.jpeg";